import { render, staticRenderFns } from "./Div_nomina.vue?vue&type=template&id=46230243"
import script from "./Div_nomina.vue?vue&type=script&lang=js"
export * from "./Div_nomina.vue?vue&type=script&lang=js"
import style0 from "./Div_nomina.vue?vue&type=style&index=0&id=46230243&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports